var image_upload_default = {
  "container": "JIsdI",
  "disabled": "Gz8nY",
  "imageInput": "PVxCe",
  "overlay": "C0hkp",
  "text": "uoES3",
  "shown": "_7WdmT",
  "hide": "muPCb",
  "spinner": "_2gazH",
  "spin": "ot4Bx"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
